// Base URL configuration
export const BASE_URL = "https://gogreek-adminapi.appgrowthcompany.com";

// Log BASE_URL for debugging (remove in production)
// if (process.env.NODE_ENV === "development") {
//   console.log("🔧 BASE_URL:", BASE_URL);
//   console.log("🔧 REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
// }

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/onboarding/admin/login",
    SEND_OTP: "/onboarding/admin/send-otp",
    VERIFY_OTP: "/onboarding/admin/verify-otp",
    CHANGE_PASSWORD: "/onboarding/admin/change-password",
    PROFILE: "/auth/profile",
    ACCOUNT: "/auth/account",
    LOGOUT: "/onboarding/admin/logout",
    REFRESH_TOKEN: "/auth/refresh",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
  },

  // User endpoints
  USERS: {
    LIST: "/users",
    DETAIL: (id: string) => `/users/${id}`,
    CREATE: "/users",
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
  },

  // Customer endpoints
  CUSTOMER: {
    LIST: "/customer/admin",
    DETAIL: (id: string) => `/customer/admin/${id}`,
    UPDATE: (id: string) => `/customer/admin/${id}`,
    DELETE: (id: string) => `/customer/admin/${id}`,
  },

  // Admin endpoints
  ADMIN: {
    PROFILE: "/onboarding/admin",
    UPDATE_PROFILE: "/onboarding/admin/update",
  },

  // Common endpoints
  COMMON: {
    UPLOAD_FILE: "/uploadFile",
  },

  // Flavour endpoints
  FLAVOUR: {
    LIST: "/flavour/admin",
    CREATE: "/flavour/admin",
    UPDATE: (id: string) => `/flavour/admin/${id}`,
    DELETE: (id: string) => `/flavour/admin/${id}`,
  },

  // Box Art endpoints
  BOX_ART: {
    LIST: "/box/admin",
    CREATE: "/box/admin",
    UPDATE: (id: string) => `/box/admin/${id}`,
    DELETE: (id: string) => `/box/admin/${id}`,
  },

  // Topping endpoints
  TOPPING: {
    LIST: "/topping/admin",
    CREATE: "/topping/admin",
    UPDATE: (id: string) => `/topping/admin/${id}`,
    DELETE: (id: string) => `/topping/admin/${id}`,
  },

  // Greek Box endpoints
  GREEK_BOX: {
    LIST: "/greekbox/admin",
    CREATE: "/greekbox/admin",
    UPDATE: (id: string) => `/greekbox/admin/${id}`,
    DELETE: (id: string) => `/greekbox/admin/${id}`,
  },

  // Yogurt Type endpoints
  YOGURT: {
    LIST: "/yogurt/admin",
    CREATE: "/yogurt/admin",
    UPDATE: (id: string) => `/yogurt/admin/${id}`,
    DELETE: (id: string) => `/yogurt/admin/${id}`,
    FLAVOR_LIST: "/yogurt/admin/yogurtFlavor",
    FLAVOR_LIST_BY_ID: (id: string) => `/yogurt/admin/yogurtFlavor/${id}`,
    FLAVOR_CREATE: "/yogurt/admin/yogurtFlavor",
    FLAVOR_UPDATE: (id: string) => `/yogurt/admin/yogurtFlavor/${id}`,
    FLAVOR_DELETE: (id: string) => `/yogurt/admin/yogurtFlavor/${id}`,
    TOPPING_LIST: "/yogurt/admin/yogurtTopping",
    TOPPING_CREATE: "/yogurt/admin/yogurtTopping",
    TOPPING_UPDATE: (id: string) => `/yogurt/admin/yogurtTopping/${id}`,
    TOPPING_DELETE: (id: string) => `/yogurt/admin/yogurtTopping/${id}`,
  },

  // Product endpoints
  PRODUCT: {
    LIST: "/product/admin",
    CREATE: "/product/admin",
    UPDATE: (id: string) => `/product/admin/${id}`,
    DELETE: (id: string) => `/product/admin/${id}`,
  },

  // Category endpoints
  CATEGORY: {
    LIST: "/category/admin",
    CREATE: "/category/admin",
    UPDATE: (id: string) => `/category/admin/${id}`,
    DELETE: (id: string) => `/category/admin/${id}`,
  },

  // Store endpoints
  STORE: {
    LIST: "/store/admin",
    CREATE: "/store/admin",
    DETAIL: (id: string) => `/store/admin/${id}`,
    UPDATE: (id: string) => `/store/admin/${id}`,
    DELETE: (id: string) => `/store/admin/${id}`,
    INVENTORY: "/store/admin/inventory",
    MANAGE_INVENTORY: "/store/admin/manageInventory",
  },

  // CMS endpoints
  CMS: {
    GET: "/cms/admin",
    UPDATE: "/cms/admin",
  },

  // Dispatcher endpoints
  DISPATCHER: {
    LIST: "/dispatcher/admin",
    DETAIL: (id: string) => `/dispatcher/admin/${id}`,
    CREATE: "/dispatcher/admin",
    UPDATE: (id: string) => `/dispatcher/admin/${id}`,
    DELETE: (id: string) => `/dispatcher/admin/${id}`,
  },

  // FAQ endpoints
  FAQ: {
    LIST: "/faq/admin",
    CREATE: "/faq/admin",
    UPDATE: (id: string) => `/faq/admin/${id}`,
    DELETE: (id: string) => `/faq/admin/${id}`,
  },

  // Orders endpoints
  ORDERS: {
    LIST: "/order/admin",
    DETAIL: (id: string) => `/order/admin/${id}`,
    STATUS_UPDATE: "/order/admin/status",
  },

  // Loyalty endpoints
  LOYALTY: {
    LIST: "/loyalty/admin",
    CREATE: "/loyalty/admin",
    DELETE: (id: string) => `/loyalty/admin/${id}`,
    UPDATE: (id: string) => `/loyalty/admin/${id}`,
    SETTINGS_UPDATE: "/loyalty/admin/settings/update",
  },

  // Ratings endpoints
  RATINGS: {
    LIST: "/ratings/admin",
    DELETE: (id: string) => `/ratings/admin/${id}`,
  },

  // Manage Sub-Admin endpoints
  MANAGE_SUB_ADMIN: {
    LIST: "/subadmin/admin",
    DETAIL: (id: string) => `/subadmin/admin/${id}`,
    UPDATE: (id: string) => `/subadmin/admin/${id}`,
    DELETE: (id: string) => `/subadmin/admin/${id}`,
  },

  // Manage Roles endpoints
  MANAGE_ROLES: {
    LIST: "/accessrole/admin",
    DETAIL: (id: string) => `/accessrole/admin/${id}`,
    UPDATE: (id: string) => `/accessrole/admin/${id}`,
    DELETE: (id: string) => `/accessrole/admin/${id}`,
  },
  // Revenue endpoints
  REVENUE: {
    ANALYTICS: "/revenue/admin/analytics",
  },
  // etc.
  // Dashboard endpoints
  DASHBOARD: {
    GET: "/home/admin/dashboard",
    GRAPH: "/home/admin/graph-data",
  },
} as const;
